import Rx from 'rlink-rx';
import setRequestPending from 'rlink-data-connector/setRequestPending';

let subjects = {};

export default function streamProviderFromFetcher (fetcher) {
  return ({
    getCaches,
    request,
    requestArgs,
  }) => {
    let requestKey = request.keyFor(...requestArgs);
    let subject = subjects[requestKey];

    if (!subject) {
      subjects[requestKey] = new Rx.ReplaySubject(1);
      subject = subjects[requestKey];
      fetcher({
        getCaches,
        request,
        requestArgs,
        fetchStarted () {
          subject.onNext([setRequestPending(request, requestArgs)]);
        },
        fetchCompleted (...embeddedValues) {
          subject.onNext(embeddedValues);
        },
        fetchFailed (error) {
          subject.onError(error);
        },
      });
    }
    return subject;
  };

}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/streams/streamProviderFromFetcher.js